/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QTable from 'quasar/src/components/table/QTable.js';import QTh from 'quasar/src/components/table/QTh.js';import QTr from 'quasar/src/components/table/QTr.js';import QTd from 'quasar/src/components/table/QTd.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QField from 'quasar/src/components/field/QField.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QInput from 'quasar/src/components/input/QInput.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Notify from 'quasar/src/plugins/Notify.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import Cookies from 'quasar/src/plugins/Cookies.js';import Meta from 'quasar/src/plugins/Meta.js';import Loading from 'quasar/src/plugins/Loading.js';import Platform from 'quasar/src/plugins/Platform.js';;
Vue.use(Quasar, {
  config: {
    "screen": {
      "bodyClasses": true
    }
  },
  components: {
    QLayout: QLayout,
    QHeader: QHeader,
    QDrawer: QDrawer,
    QPageContainer: QPageContainer,
    QPage: QPage,
    QToolbar: QToolbar,
    QToolbarTitle: QToolbarTitle,
    QBtn: QBtn,
    QBtnGroup: QBtnGroup,
    QIcon: QIcon,
    QList: QList,
    QItem: QItem,
    QItemSection: QItemSection,
    QItemLabel: QItemLabel,
    QCard: QCard,
    QCardSection: QCardSection,
    QCardActions: QCardActions,
    QSeparator: QSeparator,
    QTable: QTable,
    QTh: QTh,
    QTr: QTr,
    QTd: QTd,
    QMarkupTable: QMarkupTable,
    QTabs: QTabs,
    QTab: QTab,
    QTabPanel: QTabPanel,
    QTabPanels: QTabPanels,
    QField: QField,
    QDialog: QDialog,
    QInput: QInput,
    QSelect: QSelect,
    QCheckbox: QCheckbox,
    QRadio: QRadio,
    QSpace: QSpace,
    QTooltip: QTooltip,
    QDate: QDate,
    QTime: QTime,
    QPopupProxy: QPopupProxy
  },
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup
  },
  plugins: {
    Notify: Notify,
    LocalStorage: LocalStorage,
    Cookies: Cookies,
    Meta: Meta,
    Loading: Loading,
    Platform: Platform
  }
});